<template>
    <div class="card">
      <div class="card-header pb-0">
        <h6>Batch Detail table</h6>
      </div>
      <div class="card-body px-0 pt-0 pb-2">
        <div class="table-responsive p-0">
          <table class="table align-items-center mb-0">
            <thead>
              <tr>
                <th
                  class="text-uppercase text-weight-bold font-weight-bolder">
                  Details
                </th>
                <th
                  class="text-uppercase text-weight-bold font-weight-bolder ps-2">
                  Type
                </th>
                <th
                class="text-uppercase text-weight-bold font-weight-bolder ps-2">
                  Date
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,index) in batchdetaillist" :key="index">
                <td>
                  <div class="d-flex px-2 py-1">
                    <div class="d-flex flex-column justify-content-center">
                      <h6 class="mb-0 text-sm">{{ item.detail }}</h6>
                    </div>
                  </div>
                </td>
                <td>
                  <h6 class="text-xs font-weight-bold mb-0">{{ item.type }}</h6>
                </td>
                <td>
                  <p class="text-xs font-weight-bold mb-0">{{ item.date }}</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </template>

  
<script>
import axios from 'axios';

export default {
  name:'batchDetailSelect',
  data(){
    return {
      batchdetaillist: [],
      batchblockid: [],
      batchno:''
    }
  },
  mounted(){
    this.batchno = this.$route.params.id;
    this.getBatchProfile();
    this.listAllBatchBlockId();
  },
  methods: {
    getBatchProfile(){
        axios.get('nursery/listAllBatchDetails/' + this.batchno)
            .then(res => {
              this.batchdetaillist = res.data.batchdetaillist;
            }).catch(function (error){
                
              console.log('Error',error.message);
            });
    },
    listAllBatchBlockId(){
        axios.get('nursery/listAllBatchBlockId')
            .then(res => {
              this.batchblockid = res.data.batchblockid;
            }).catch(function (error){
                
              console.log('Error',error.message);
            });
    }
  },
}
</script>
  